/**
 * @author        matt@zumper.com (Matthieu Devlin)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   filter change thunk
 */

import { getUser } from '@zcode-ui/web-zumper-global-state'
import { FILTER_CHANGE } from '@zcode-ui/web-zumper-integrations'
import { event } from '@zcode/integrations'
import type { State } from '@zcode/state-type'
import { getCurrentLocation } from '../../../inspectors'
import { selectFilters } from '../../filters/selectors'
import type { Dispatch } from '../../types'

export const trackFilterChangeEvent = () => (dispatch: Dispatch, getState: () => State) => {
  const state = getState()
  const user = getUser(state)
  const filters = selectFilters(state)
  const location = getCurrentLocation(state)

  return dispatch(event({ name: FILTER_CHANGE, user, filters, location }))
}
